import { Box, Flex, Icon, Link, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { FaLinkedin, FaGithub, } from 'react-icons/fa'
import { SiUpwork } from 'react-icons/si'

const Footer = () => {
    const color = useColorModeValue('gray.500', 'gray.500')

    return <Flex mt={'12'} mb={'4'} flexFlow={'column'} maxW={'container.lg'} w={'full'} alignContent={'center'}>
        <Flex color={color} alignItems={'center'} justifyContent={'center'}>
            <Link isExternal href='https://github.com/Vong3432'>
                <Icon as={FaGithub} mx={'3'} w={26} h={26} />
            </Link>
            <Link isExternal href='https://www.linkedin.com/in/vong-nyuk-soon-41881915a/'>
                <Icon as={FaLinkedin} mx={'3'} w={26} h={26} />
            </Link>
            <Link isExternal href='https://www.upwork.com/freelancers/~01e51164a97c19cdcc'>
                <Icon as={SiUpwork} mx={'3'} w={26} h={26} />
            </Link>
        </Flex>

        <Text mt={'2'} color={color} fontSize={'sm'} fontWeight={'medium'} textAlign={'center'}>vongnyuksoon2000@gmail.com</Text>
        <Text mt={'2'} color={color} fontSize={'xs'} as='i' textAlign={'center'}>Hand crafted by Vong Nyuk Soon</Text>

    </Flex>
};

export default Footer;
